import { ThunkAction, Dispatch } from 'redux-thunk';
import { Action } from '../../definitions/types';
import { AppState } from '../reducers';
import { PackageType } from '../reducers/pricing';
import * as Actions from './actions-consts';
import { isValidTrialType } from '../../modules/affiliate';
import { PACKAGE_TYPE_FREE } from '../../modules/constants';
import { preselectPackage } from './pricing';
import { preselectTemplate } from './template';
import { preselectIndustry, preselectProduct } from './intent';
import { isValidPackageType } from '../../modules/getPackages';
import { isBase64 } from '../../modules/helpers';

export interface Query {
  industry?: string;
  subtype?: string;
  package?: PackageType; // tslint:disable-line no-reserved-keywords
  experiment?: string;
  trial?: string;
  ref?: string;
  product?: string;
}

export function setEasyMarketingTrackId(trackingId: string): Action<string> {
  return {
    type: Actions.SET_EASY_MARKETING_TRACKING_ID,
    payload: trackingId,
  };
}

export function setAffiliateId(ref: string): Action<string> {
  return {
    type: Actions.SET_AFFILIATE_ID,
    payload: ref,
    meta: {
      tracked: { action: 'affiliate-id', label: 'set' },
    },
  };
}

export function setTrialType(trial: string): Action<string> {
  return {
    type: Actions.SET_TRIAL_TYPE,
    payload: trial,
    meta: {
      tracked: { action: 'trial-type', label: 'set' },
    },
  };
}

export const preselectByQuery = (query: Query): ThunkAction<void, AppState, void> => {
  return (dispatch: Dispatch<AppState>) => {
    const { industry, subtype, trial, product } = query;

    if (industry) {
      dispatch(preselectIndustry(industry));
    }

    if (subtype) {
      dispatch(preselectTemplate(subtype));
    }

    if (product) {
      dispatch(preselectProduct(product));
    }

    if (isValidPackageType(query.package)) {
      dispatch(preselectPackage(query.package));
    }

    if (isValidTrialType(trial)) {
      dispatch(setTrialType(trial));
      dispatch(preselectPackage(PACKAGE_TYPE_FREE));
    }

    if (isBase64(trial) && isValidTrialType(atob(trial))) {
      dispatch(setTrialType(atob(trial)));
      dispatch(preselectPackage(PACKAGE_TYPE_FREE));
    }
  };
};

export function clearTemporaryState(): Action<void> {
  return {
    type: Actions.CLEAR_TEMPORARY_STATE,
  };
}

interface UserHadPersistedStateInterface {
  pathname: string;
  referrer: string;
}

export function userHadPersistedState(
  pathname: string,
  referrer: string
): Action<UserHadPersistedStateInterface> {
  return {
    type: Actions.USER_HAD_PERSISTED_STATE,
    payload: {
      pathname,
      referrer,
    },
    meta: {
      tracked: { action: 'persisted-state', label: 'existed' },
    },
  };
}
